
<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5767_29780)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.75 6.41667C2.75 4.39162 4.39162 2.75 6.41667 2.75C8.44171 2.75 10.0833
        4.39162 10.0833 6.41667C10.0833 7.39508 9.70011 8.284 9.07557 8.94149C9.05143
        8.96148 9.028 8.98278 9.00539 9.00539C8.98278 9.028 8.96148 9.05143 8.94149
        9.07557C8.284 9.70011 7.39508 10.0833 6.41667 10.0833C4.39162 10.0833 2.75
        8.44171 2.75 6.41667ZM9.65397 11.0682C8.73626 11.7081 7.62028 12.0833 6.41667
        12.0833C3.28705 12.0833 0.75 9.54628 0.75 6.41667C0.75 3.28705 3.28705 0.75 6.41667
        0.75C9.54628 0.75 12.0833 3.28705 12.0833 6.41667C12.0833 7.62028 11.7081 8.73626
        11.0682 9.65397L12.9571 11.5429C13.3476 11.9334 13.3476 12.5666 12.9571
        12.9571C12.5666 13.3476 11.9334 13.3476 11.5429 12.9571L9.65397 11.0682Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5767_29780">
        <rect
          width="14"
          height="14"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
